import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import "./LedgerMoreDetail.scss";
import Header from "../../../../Home/Header/Header";
import { Button } from "@mui/material";

const LedgerMoreDetail = () => {
  const navigate = useNavigate();
  const { state } = useLocation();
  const { entry, company } = state || {};

  return (
    <div>
      <Header otherPage={true} title={"Ledger Deatil"} />
      <div className="voucher-detail-container">
        <div className="header">
          <div>
            <div className="voucher-title">Voucher no:</div>
            <div className="voucher-type">{entry?.type || "Purchase"}</div>
          </div>
          <div className="amount">₹ {entry?.amount?.toLocaleString()}</div>
          <div className="company">{company}</div>
        </div>

        <div className="dates">
          <div>
            <p style={{ margin: "2px", fontSize: "13px" }}>Invoice Date</p>
            <p style={{ margin: "2px", fontSize: "14px", fontWeight: 600 }}>
              {entry?.date}
            </p>
          </div>
          <div>
            <p style={{ margin: "2px", fontSize: "13px" }}>Due Date</p>
            <p style={{ margin: "2px", fontSize: "14px", fontWeight: 600 }}>
              {entry?.date}
            </p>
          </div>
        </div>

        <div className="items">
          <div className="item">
            <p style={{ margin: "2px", fontSize: "15px" }}>
              Pringles Original Flavored Potato Crisps 107 Gm
            </p>
            <p style={{ margin: "2px", fontSize: "13px" }}>Qty: 1,000 pkt</p>
            <p style={{ margin: "2px", fontSize: "13px" }}>Rate: ₹165 / pkt</p>
            <p style={{ margin: "2px", fontSize: "14px", fontWeight: 600 }}>
              ₹ {entry?.amount?.toLocaleString()}
            </p>
          </div>
        </div>

        <div className="summary">
          <p style={{ margin: "2px", fontSize: "15px" }}>
            Net Amount:
            <span style={{ margin: "2px", fontSize: "16px", fontWeight: 600 }}>
              {" "}
              ₹ {entry?.amount?.toLocaleString()}
            </span>
          </p>
          <p style={{ margin: "2px", fontSize: "15px" }}>
            Gross Total:{" "}
            <span style={{ margin: "2px", fontSize: "16px", fontWeight: 600 }}>
              ₹ {entry?.amount?.toLocaleString()}
            </span>
          </p>
        </div>

        <div className="terms">
          <p style={{margin: '2px', fontSize :'16px', fontWeight: 600}}>Due Date: {entry?.date}</p>
        </div>

        <Button className="share-button">SHARE INVOICE</Button>
      </div>
    </div>
  );
};

export default LedgerMoreDetail;
